import { render } from "./JournalRegister.vue?vue&type=template&id=614eadda&scoped=true"
import script from "./JournalRegister.vue?vue&type=script&lang=js"
export * from "./JournalRegister.vue?vue&type=script&lang=js"

import "./JournalRegister.vue?vue&type=style&index=0&id=614eadda&scoped=true&lang=css"

import exportComponent from "D:\\code\\h5\\vue-lib\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-614eadda"]])

export default __exports__